<script>
import _ from 'lodash'
import { isMobileMixin } from '@src/mixins/isMobileMixin'

export default {
  mixins: [isMobileMixin],
  props: {
    prospect: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      addMargin: false,
      yVisibleOffset: 100,
    }
  },
  computed: {
    bottomOffset() {
      let yOffset = _.isEmpty(this.$store.getters['survey/currentPageSurvey']) ? 20 : 95
      if (this.isMobile) {
        yOffset += 80
      }

      if (!this.addMargin || !this.isMobile) {
        return yOffset
      }

      return yOffset + 80
    },
    showRider() {
      return !this.$route.meta?.hideProspectRider
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      this.addMargin = window.scrollY > this.yVisibleOffset
    },
  },
}
</script>

<template>
  <div v-if="prospect && showRider" class="d-contents">
    <div :class="[$style.prospectContainer]" :style="{ bottom: bottomOffset + 'px' }" @click="$emit('openProspect')">
      <div :class="$style.iconContainer">
        <BaseIcon :class="$style.userPlusIcon" name="user-plus"></BaseIcon>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.iconContainer {
  position: absolute;
  top: 53%;
  left: 50%;
  z-index: 20000;
  cursor: pointer;
  transform: translateX(-50%) translateY(-50%);
}

.userPlusIcon {
  display: inline;
  font-size: 22px;
  color: white;
  animation-name: shake;
  animation-duration: 0.5s;
  animation-timing-function: ease-in-out;
  animation-delay: 0.5s;
  animation-iteration-count: 3;
}

.prospectContainer {
  @media (max-width: $lg-breakpoint) {
    bottom: 100px;
  }

  position: fixed;
  right: 22px;
  bottom: 20px;
  z-index: 99;
  width: 60px;
  height: 60px;
  cursor: pointer;
  background: $secondary-green;
  border-radius: 50%;
  transition: all 0.3s ease;
}

@keyframes shake {
  0%,
  100% {
    transform: rotate(0deg);
  }
  20%,
  60% {
    transform: rotate(12deg);
  }
  40%,
  80% {
    transform: rotate(-12deg);
  }
}
</style>
